import {
  Mixins,
  Component,
  Prop,
  Watch,
} from 'vue-property-decorator';
import { ITABLECOLCONF } from '@/types/base.d';
import api from '@/api/set';
import publicApi from '@/api/public';
import pageMixin from '../../../../mixins/pageMixin';


@Component
export default class tableMixin extends Mixins(pageMixin) {
  @Prop({
    type: String,
    required: true,
  }) type!: string;

  @Prop({
    default: false,
  }) typeList!: any;

  private sList: any = [];

  public column: Array<ITABLECOLCONF> = [{
    label: '类型',
    prop: 'typeLabel',
    align: 'center',
  },
  {
    label: '名称',
    prop: 'title',
    align: 'center',
    tooltip: true,
  },
  {
    label: '是否显示',
    prop: 'visible',
    align: 'center',
    custom: true,
    tags: [{
      value: '1',
      type: 'warning',
      label: '否',
    }, {
      value: '0',
      type: 'success',
      label: '是',
    }, {
      value: 'null',
      type: 'info',
      label: '',
    }],
  },
  {
    label: '值',
    align: 'center',
    prop: 'value',
  }, {
    label: '排序',
    align: 'center',
    prop: 'sort',
  }, {
    label: '创建时间',
    prop: 'createTime',
    align: 'center',
  }, {
    label: '操作',
    custom: true,
    minWidth: '120',
    maxBtn: 2,
    btnList: [
      {
        title: '编辑',
        name: '/set/normal:update',
        icon: 'edit',
        type: 'info',
        callback: this.handleUpdateForm,
        log: {
          name: '系统配置 - 编辑',
          component: 'set/tableMixin',
        },
      },
      // {
      //   title: '删除',
      //   name: '/set:remove',
      //   icon: 'remove',
      //   type: 'info',
      //   callback: this.handleRmove,
      //   log: {
      //     name: '系统配置 - 删除',
      //     component: 'set/tableMixin',
      //   },
      // },
    ],
    align: 'center',
  }];

  public columnCopy = this.column.concat()

  private loading: boolean = true;

  public difficulties: any = [];

  private tableFlag: boolean = true;

  mounted() {
    this.getData(this.type);
  }

  /* eslint-disable class-methods-use-this */
  /**
   * @author ruixue
   * @desc 获取配置列表
   */
  getData(type: string) {
    this.tableFlag = false;
    this.column = this.columnCopy.concat();
    if (type === 'difficulty' || type === 'knowledge') {
      const item = {
        label: '难易程度图片',
        align: 'center',
        prop: 'iconPath',
        custom: true,
        icon: true,
      };
      this.column.splice(2, 0, item);
    }
    if(type === 'customerStatus') {
      const item = {
        label: '是否有效',
        align: 'center',
        prop: 'effectiveStatus',
        custom: true,
        tags: [{
          value: 'EFFICIENT',
          type: 'success',
          label: '有效',
        }, {
          value: 'INVALID',
          type: 'warning',
          label: '无效',
        }],
      };
      this.column.splice(2, 0, item);
    }
    this.loading = true;
    api.getConPage(this.page, type).then((res: any) => {
      this.sList = res.content;
      if (this.type === 'knowledge') {
        publicApi.getType('difficulty').then((result: any) => {
          this.difficulties = result;
          this.sList.map((el: any) => {
            const obj: any = el;
            const paths = this.difficulties.filter((em: any) => em.value === el.remark);
            obj.iconPath = paths.length === 0 ? '' : paths[0].iconPath;
            return true;
          });
        });
      }
      this.total = res.totalElements;
      this.loading = false;
      this.tableFlag = true;
    });
  }

  /* eslint-disable class-methods-use-this */
  handleUpdateForm(row: any) {}

  /**
   * @author ruixue
   * @desc 删除配置操作
   * @param { any } row 行数据
  */
  handleRmove(row: any) {
    this.confirm('此操作将永久删除该数据, 是否继续?', {
      title: '警告',
      loading: true,
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      iconType: 'warning',
    }).then((close: Function) => {
      api.removeconfig({ id: row.pid }).then(() => {
        this.getData(this.type);
        close();
        this.$log({
          title: '系统配置 - 删除 - 确定',
          component: 'org/manage/tableMixin',
        });
      }).catch(() => close());
    }).catch(() => this.$log({
      title: '系统配置 - 删除 - 取消',
      component: 'org/manage/tableMixin',
    }));
  }
}
